import { Container, Section, Eyebrow } from '@/components/primitives/Container';
import { ArgentinaMap } from '@/components/map/ArgentinaMap';
import { STATUS_LABELS, STATUS_ORDER } from '@/data/coverage';
import { useLiveCoverage } from '@/hooks/useLiveCoverage';

export function Jurisdicciones() {
  const { isAvailable, counts, total } = useLiveCoverage();

  return (
    <>
      <Section className="pt-12 sm:pt-16">
        <Container width="editorial">
          <Eyebrow>Cobertura federal</Eyebrow>
          <h1 className="mt-4 font-serif text-4xl font-normal tracking-tight sm:text-5xl">
            El sistema curricular argentino, jurisdicción por jurisdicción.
          </h1>
          <p className="mt-6 max-w-prose text-lg leading-relaxed text-ink-muted">
            24 diseños jurisdiccionales. Núcleos de Aprendizajes Prioritarios nacionales. Comparables
            y trazables.
          </p>
        </Container>
      </Section>

      <Section className="pt-0">
        <Container>
          <ArgentinaMap />
        </Container>
      </Section>

      <Section ariaLabelledby="cobertura-title" className="bg-paper-tinted/40">
        <Container width="editorial">
          <Eyebrow>Notas sobre cobertura</Eyebrow>
          <h2 id="cobertura-title" className="mt-3 font-serif text-3xl font-normal tracking-tight">
            Cómo entender el estado de cobertura.
          </h2>
          <dl className="mt-8 space-y-6">
            {STATUS_ORDER.map((status) => (
              <div key={status} className="border-t border-line pt-4">
                <dt className="text-base font-semibold text-ink">
                  {STATUS_LABELS[status].label}
                  {/* La cuenta acompaña al estado solo cuando la pudimos medir:
                      "0 de 0" se leería como una afirmación sobre el país. */}
                  {isAvailable && (
                    <span className="ml-3 text-sm font-normal text-ink-muted">
                      {counts[status]} de {total}
                    </span>
                  )}
                </dt>
                <dd className="mt-2 text-base leading-relaxed text-ink-muted">
                  {STATUS_LABELS[status].description}
                </dd>
              </div>
            ))}
          </dl>
          <p className="prose-editorial mt-10 text-sm">
            Estos números salen del Inventario de Activos Curriculares en el momento en que abrís la
            página, y cambian a medida que sumamos jurisdicciones. Si la tuya todavía no tiene fuente
            asegurada y querés que la prioricemos, escribinos.
          </p>
        </Container>
      </Section>
    </>
  );
}
